import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {withStyles} from '@material-ui/core';
import {Title2} from '../../../components/Typography';
import Dialog from '../../../components/Dialog/Dialog';
import TextField from '@material-ui/core/TextField';
import Ratings from 'react-ratings-declarative';
import CloseButton from '../../../components/CloseButton/CloseButton';
import {PrimaryButton} from '../../../components/Buttons';

const Wrapper = styled.div`
  padding: 24px;
  display: grid;
  grid-gap: 24px;
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  align-items: center;
`;

const Title = styled(Title2)`
//   color: ${props => props.theme.orderStatusTitleColor};
`;

const DivCenter = styled.div`
  margin: auto;
`;

const styles = () => ({
  scrollPaper: {},
  paper: {
    // margin: 0,
    // // maxHeight: '90%',
    // overflowY: 'visible',
    // width: '640px',
    // borderRadius: '10px',
  },
  root: {
    width: '100%',
  },
});

const FeedbackModal = ({
  feedbackModalData,
  setFeedbackModalData,
  classes,
  sendReview,
  feedbackModalIsVisible,
  openFeedbackModal,
  closeFeedbackModal,
}) => {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);

  useEffect(() => {
    setComment('');
    setRating(0);
  }, [feedbackModalIsVisible]);

  return (
    <Dialog
      open={feedbackModalIsVisible}
      classes={classes}
      onBackdropClick={() => {
        setFeedbackModalData(null);
        closeFeedbackModal();
      }}
      scroll="body"
    >
      <Wrapper>
        <TitleWrapper>
          <Title id="Feedback-RateYourOrder">Rate Your Order</Title>
          <CloseButton
            onClick={() => {
              setFeedbackModalData(null);
              closeFeedbackModal();
            }}
          />
        </TitleWrapper>
        <DivCenter>
          <Ratings
            id="Feedback-Ratings"
            rating={rating}
            widgetHoverColors="#f9d219"
            widgetRatedColors="#f9d219"
            changeRating={setRating}
          >
            <Ratings.Widget widgetDimension="30px" />
            <Ratings.Widget widgetDimension="30px" />
            <Ratings.Widget widgetDimension="30px" />
            <Ratings.Widget widgetDimension="30px" />
            <Ratings.Widget widgetDimension="30px" />
          </Ratings>
        </DivCenter>
        <div>
          <TextField
            id="Feedback-CommentField"
            type="text"
            variant="outlined"
            multiline
            rows={3}
            className={classes.root}
            value={comment}
            onChange={e => setComment(e.target.value)}
          />
        </div>
        <DivCenter>
          <PrimaryButton
            id="Feedback-SendReviewButton"
            onClick={() =>
              sendReview(feedbackModalData.orderId, {comment, rating})
            }
            disabled={!rating || !comment}
          >
            Send
          </PrimaryButton>
        </DivCenter>
      </Wrapper>
    </Dialog>
  );
};

export default withStyles(styles)(FeedbackModal);
